/// <reference path="../../core/services/resource.service.ts" />
'use strict';

namespace ekh {

    const ONE_SEVEN = !!TRPCONFIG.Rtl ? '‎7 x 1' : '1 x 7';
    const ONE_TEN = !!TRPCONFIG.Rtl ? '‎10 x 1' : '1 x 10';
    const TWO_SEVEN = !!TRPCONFIG.Rtl ? '‎7 x 2' : '2 x 7';
    const ONE_TWO_THREE = !!TRPCONFIG.Rtl ? '‎23 x 1' : '1 x 23';
    const TWO_TWO_THREE = !!TRPCONFIG.Rtl ? '‎23 x 2' : '2 x 23';
    const TWO_THREE_TWO = !!TRPCONFIG.Rtl ? '‎32 x 2' : '2 x 32';


    export enum TransformedType {
        EconomySpecial,
        EconomySaver,
        EconomyFlex,
        EconomyFlexPlus,
        PremiumEconomyFlexPlus,
        BusinessSpecial,
        BusinessSaver,
        BusinessFlex,
        BusinessFlexPlus,
        FirstSaver,
        FirstFlex,
        FirstFlexPlus,
        NotDefined
    }

    export enum AttributeTypes {
        Baggage = 0,
        CabinBaggage,
        SeatsSelection,
        Meals,
        WiFi,
        Refundable,
        Changes,
        PriorityCheckin,
        FastTrack
    }

    export interface IBrandedFareType {
        FlightSectors: IFlightSector[];
        BrandedFareTypeTotalPrice: number;
        [key: string]: any;
    }

    export interface IFlightSector {
        [key: string]: any;
        TransformedType: TransformedType;
        BaggageType: string;
        BaggageText: string;
        CabinBaggageText: string;
        SeatsSelectionText: string;
        ChauffeurText: string;
    }

    export class BrandedFareTypesService {

        constructor(
            private dateUtil: any,
            private guidService: Core.GuidService,
            private resourceService: Core.ResourceService,
            private basketStore: any
        ) {
        }

        public allPayloads: any = [];
        public sentApi: boolean = false;
        public brandedFares: any = [];
        public flightMilesToPkgPP: number = 0;
        private isEKNative: boolean = TRPCONFIG.Domain.EnableEKNativeFlightSupplier;

        public transform(brandedFareType: { [key: string]: any }): IBrandedFareType {
            const flightSectors = brandedFareType.FlightSectors.map(fs => {
                fs.TransformedType = this._getTransformedType(fs.BrandTitle);
                fs.BaggageType = this._getBaggageType(fs);
                fs.BaggageText = this.getBaggage(fs);
                fs.CabinBaggageText = this.getCabinBaggage(fs);
                fs.ChauffeurText = this.getChauffeur(fs);
                fs.SeatsSelectionText = this.getSeatsSelection(fs);
                return fs;
            });

            const brandedFareTypePrice = this.getBrandedFareTypePrice(brandedFareType);
            this.setSkywards(brandedFareType);

            let defaultPrice;

            return {
                ...brandedFareType,
                FlightSectors: flightSectors,
                BrandedFareTypeTotalPrice: brandedFareTypePrice
            };
        }

        public squeeze(brandedfareTypes: IBrandedFareType[]): IBrandedFareType[] {
            if(TRPCONFIG.Domain.EnableBrandedFareDeduplication) {
                let uniqueBFTNames: string[] =[];
                let discardedBFTNames: string[] =[];
                const selectedBFT = brandedfareTypes.filter((bft)=>{
                    return bft.Legs && bft.Legs.length ? true : false;
                });
                if (selectedBFT && selectedBFT.length) {
                    uniqueBFTNames.push(selectedBFT[0].FlightSectors[0].BrandTitle);
                }
                const sameBFTAll = brandedfareTypes.filter((bft)=>{
                    return bft.FlightSectors[0].BrandTitle === bft.FlightSectors[1].BrandTitle;
                });
                const diffBFT = brandedfareTypes.filter((bft)=>{
                    return bft.FlightSectors[0].BrandTitle !== bft.FlightSectors[1].BrandTitle;
                });
                let sameBFT: IBrandedFareType[] =[];
                for (let i = 0; i < sameBFTAll.length; i++) {
                    if(i>0) {
                        const lastBf = sameBFT[sameBFT.length-1];
                        const curBf = sameBFTAll[i];
                        const sectorFirstEqual = this._isEqualFlightSectors(
                            lastBf.FlightSectors[0],
                            curBf.FlightSectors[0]
                        );
                        const sectorSecondEqual = this._isEqualFlightSectors(
                            lastBf.FlightSectors[1],
                            curBf.FlightSectors[1]
                        );
                        if (!sectorFirstEqual || !sectorSecondEqual) {
                            sameBFT.push(curBf);
                            uniqueBFTNames.push(curBf.FlightSectors[0].BrandTitle);
                        } else {
                            discardedBFTNames.push(curBf.FlightSectors[0].BrandTitle);
                        }
                    } else {
                        sameBFT.push(sameBFTAll[i]);
                        uniqueBFTNames.push(sameBFTAll[i].FlightSectors[0].BrandTitle);
                    }
                }
                const dedupDiffBFT = diffBFT.filter((bft)=>{
                    if (uniqueBFTNames.indexOf(bft.FlightSectors[0].BrandTitle) < 0 &&
                    discardedBFTNames.indexOf(bft.FlightSectors[0].BrandTitle) < 0) {
                        uniqueBFTNames.push(bft.FlightSectors[0].BrandTitle);
                        return true;
                    }
                });
                const mergedBFT = dedupDiffBFT.length ? sameBFT.concat(dedupDiffBFT) : sameBFT;
                const selectedBFTPresent = mergedBFT.filter((bft)=>{
                    return bft.Legs && bft.Legs.length ? true : false;
                });
                const final = selectedBFTPresent.length ? mergedBFT : mergedBFT.concat(selectedBFT);
                const sortedBFT = final.sort((a,b)=>
                    (a.AdultFare.Amount+a.AdultTax.Amount)-(b.AdultFare.Amount+b.AdultTax.Amount));
                return sortedBFT;
            } else {
                return brandedfareTypes.reduce((prev: IBrandedFareType[], curBf: IBrandedFareType) => {
                    if (prev.length) {
                        const lastBf = prev.slice(-1)[0];
                        const sectorFirstEqual = this._isEqualFlightSectors(
                            lastBf.FlightSectors[0],
                            curBf.FlightSectors[0]
                        );
                        const sectorSecondEqual = this._isEqualFlightSectors(
                            lastBf.FlightSectors[1],
                            curBf.FlightSectors[1]
                        );

                        if (!sectorFirstEqual || !sectorSecondEqual) {
                            prev.push(curBf);
                        }
                    } else {
                        prev.push(curBf);
                    }
                    return prev;
                }, [] as IBrandedFareType[]);
            }
        }

        private getCabinName(title) {
            let classes = [
                'Premium Economy',
                'Economy',
                'Business',
                'First'
            ];

            for (let i = 0; i < classes.length; i++) {
                if (title.match(classes[i])) {
                    return classes[i];
                }
            }
        }

        private addCabinType(data) {
            if (!data.CabinType) {
                let cabinType = this.getCabinName(data.BrandTitle);
                data.CabinType = cabinType;
            }
        }

        private _isEqualCabinClass(oneFs: IFlightSector, secondFs: IFlightSector): boolean {
            if (oneFs.BrandTitle && secondFs.BrandTitle) {
                return oneFs.BrandTitle === secondFs.BrandTitle;
            } else {
                return false;
            }
        }

        private _isEqualFlightSectors(oneFs: IFlightSector, secondFs: IFlightSector): boolean {
            this.addCabinType(oneFs);
            this.addCabinType(secondFs);
            const props = [
                'BaggageText',
                'CabinBaggageText',
                'CabinType',
                'SeatsSelectionText',
                'ChauffeurText'];
            let res = true;
            for (let i = 0; i < props.length; ++i) {
                let propName = props[i];
                if (oneFs[propName] !== secondFs[propName]) {
                    res = false;
                    break;
                }
            }
            return res;
        }

        public getBrandedFareTypePrice(brandedFareType: { [key: string]: any }): number {
            if (brandedFareType.TotalAmount) {
                return brandedFareType.TotalAmount;
            }
            const adultPrice = this._getPricePerPassengerAge('Adult', brandedFareType);
            const childPrice = this._getPricePerPassengerAge('Child', brandedFareType);
            const infantPrice = this._getPricePerPassengerAge('Infant', brandedFareType);
            return adultPrice + childPrice + infantPrice;
        }

        private _getPricePerPassengerAge(type: string, brandedFareType): number {
            const fare = _.get<number>(brandedFareType, `${type}Fare.Amount`) || 0;
            const fareQuantity = _.get<number>(brandedFareType.priceQuantities, `${type}FareQuantity`) || 0;
            const tax = _.get<number>(brandedFareType, `${type}Tax.Amount`) || 0;
            const taxQuantity = _.get<number>(brandedFareType.priceQuantities, `${type}TaxQuantity`) || 0;
            return fare * fareQuantity + tax * taxQuantity;
        }

        public async getCancellationCharges(id) {
            let payload = {
                'BasketId': id
            };

            try {
                let url = `/api/holidays/basketcancellationcharges`;
                const response = await fetch(url, {
                    method: 'post',
                    body: JSON.stringify(payload),
                    mode: 'cors',
                    headers: new Headers({
                        'Content-Type': 'application/json'
                    })
                });

                const details = await response.json();
                return details;
            } catch (error) {
                console.log('error', error);
                throw error;
            }
        }

        public getBaggage(sector: IFlightSector) {
            if(this.isEKNative) {
                if (sector.BaggageAllowanceKgPerBag < 0) {
                    return `${sector.BaggageAllowanceTotalKg} ${this.resourceService.get('BRANDED_FARE_TYPES_KGPP')}`;
                } else {
                    switch (sector.BaggageType) {
                        case 'ONE_TWO_THREE':
                            return `${ONE_TWO_THREE} ${this.resourceService.get('BRANDED_FARE_TYPES_KGPP')}`;
                        case 'PIECE_CONCEPT':
                            return this.resourceService.get('BRANDED_FARE_TYPES_BAGGAGE_PIECE_CONCEPT');
                        case 'TWO_TWO_THREE':
                            return `${TWO_TWO_THREE} ${this.resourceService.get('BRANDED_FARE_TYPES_KGPP')}`;
                        case 'TWO_THREE_TWO':
                            return `${TWO_THREE_TWO} ${this.resourceService.get('BRANDED_FARE_TYPES_KGPP')}`;
                        case 'NOT_INCLUDED':
                            return this.resourceService.get('BRANDED_FARE_TYPES_BAGGAGE_NOT_INCLUDED');
                        default:
                            return this.resourceService.get('BRANDED_FARE_TYPES_BAGGAGE_NOT_INCLUDED');
                    }
                }
            } else {
                if (sector.BaggageAllowanceKgPerBag > 0) {
                    switch (sector.BaggageType) {
                        case 'ONE_TWO_THREE':
                            return `${ONE_TWO_THREE} ${this.resourceService.get('BRANDED_FARE_TYPES_KGPP')}`;
                        case 'PIECE_CONCEPT':
                            return this.resourceService.get('BRANDED_FARE_TYPES_BAGGAGE_PIECE_CONCEPT');
                        case 'TWO_TWO_THREE':
                            return `${TWO_TWO_THREE} ${this.resourceService.get('BRANDED_FARE_TYPES_KGPP')}`;
                        case 'TWO_THREE_TWO':
                            return `${TWO_THREE_TWO} ${this.resourceService.get('BRANDED_FARE_TYPES_KGPP')}`;
                        case 'NOT_INCLUDED':
                            return this.resourceService.get('BRANDED_FARE_TYPES_BAGGAGE_NOT_INCLUDED');
                        default:
                            return `${sector.BaggageAllowanceTotalKg}
                             ${this.resourceService.get('BRANDED_FARE_TYPES_KGPP')}`;
                    }
                } else if (sector.BaggageAllowanceTotalKg > 0) {
                    return `${sector.BaggageAllowanceTotalKg} ${this.resourceService.get('BRANDED_FARE_TYPES_KGPP')}`;
                } else {
                    return this.resourceService.get('BRANDED_FARE_TYPES_BAGGAGE_NOT_INCLUDED');
                }
            }
        }

        private _getBaggageType(sector: IFlightSector) {
            const attr = this._getAttribute(sector, AttributeTypes.Baggage);
            const checkedMatcher = attr.Text ? attr.Text.match(/^Checked[^\d]+(\d+)kg/) : '';
            const cabin = this._getCabin(sector);
            const isEconomySaver = sector.TransformedType === TransformedType.EconomySaver;
            const isEconomySpecial = sector.TransformedType === TransformedType.EconomySpecial;
            const isPremiumEconomyFlexPlus = sector.TransformedType === TransformedType.PremiumEconomyFlexPlus;
            if(this.isEKNative) {
                if (attr.AttributeInclusionType === 0) {
                    if (sector.BaggageAllowanceKgPerBag < 0) {
                        return checkedMatcher ? checkedMatcher[1] : '';
                    } else if (sector.BaggageAllowanceKgPerBag > 0) {
                        switch (true) {
                            case cabin === 1 && isEconomySpecial:
                                return 'ONE_TWO_THREE';
                            case cabin === 1 && isEconomySaver:
                                return 'PIECE_CONCEPT';
                            case cabin === 1:
                                return 'TWO_TWO_THREE';
                            default:
                                return 'TWO_THREE_TWO';
                        }
                    } else {
                        return 'NOT_INCLUDED';
                    }
                } else if (isPremiumEconomyFlexPlus) {
                    return sector.BaggageAllowanceTotalKg.toString();
                } else {
                    return 'NOT_INCLUDED';
                }
            } else {
                if (attr.AttributeInclusionType === 0) {
                    if (sector.BaggageAllowanceKgPerBag > 0) {
                        switch (true) {
                            case cabin === 1 && isEconomySpecial:
                                return 'ONE_TWO_THREE';
                            case cabin === 1 && isEconomySaver:
                                return 'PIECE_CONCEPT';
                            case cabin === 1:
                                return 'TWO_TWO_THREE';
                            default:
                                return 'TWO_THREE_TWO';
                        }
                    } else if (sector.BaggageAllowanceTotalKg > 0) {
                        return checkedMatcher ? checkedMatcher[1] : '';
                    } else {
                        return 'NOT_INCLUDED';
                    }
                } else if (isPremiumEconomyFlexPlus) {
                    return sector.BaggageAllowanceTotalKg.toString();
                } else {
                    return 'NOT_INCLUDED';
                }
            }
        }

        public setCabinBaggage(attr, cabin, cabinBagCount) {
            let value = '';
            if(this.isEKNative) {
                value = `${cabinBagCount} x ${attr.Description.split(' ')[0]}`;
            } else {
                if (attr.AttributeInclusionType === 0 && cabin === 1) {
                    value = ONE_SEVEN;
                } else if (attr.AttributeInclusionType === 0 && cabin === 2) {
                    value = ONE_TEN;
                } else {
                    value = TWO_SEVEN;
                }
            }
            return `${value} ${this.resourceService.get('BRANDED_FARE_TYPES_KGPP')}`;
        }

        public getCabinBaggage(sector: IFlightSector) {
            const cabin = this._getCabin(sector);
            let cabinBagCount = null;
            if(this.isEKNative) {
                cabinBagCount = sector && sector.BrandAttributes ?
                sector.BrandAttributes.filter((attr => attr.AttributeType === 1)).length : null;
            }
            const attr = this._getAttribute(sector, AttributeTypes.CabinBaggage);
            return this.setCabinBaggage(attr, cabin, cabinBagCount);
        }

        public getSeatsSelection(sector: IFlightSector) {
            if (this.isRestrictedSeats(sector)) {
                return this.resourceService.get('BRANDED_FARE_TYPES_SEAT_SELECTION_RESTRICTED');
            }
            const attr = this._getAttribute(sector, AttributeTypes.SeatsSelection);
            if (attr && attr.AttributeInclusionType === 0) {
                return this.resourceService.get('BRANDED_FARE_TYPES_SEAT_SELECTION_COMPLIMENTARY');
            } else if (attr) {
                return this.resourceService.get('BRANDED_FARE_TYPES_SEAT_SELECTION_AT_CHECK_IN');
            } else {
                return '';
            }
        }

        public isRestrictedSeats(sector: IFlightSector): boolean {
            const attr = this._getAttribute(sector, AttributeTypes.SeatsSelection);
            return attr ? (attr.AttributeInclusionType === 0 || attr.AttributeInclusionType === 3)
                && sector.TransformedType === TransformedType.BusinessSpecial : false;
        }

        public getChauffeur(sector: IFlightSector) {
            const cabin = this._getCabin(sector);
            return sector.TransformedType === TransformedType.BusinessSpecial
                || sector.TransformedType === TransformedType.PremiumEconomyFlexPlus
                || cabin === 1 ?
                this.resourceService.get('BRANDED_FARE_TYPES_CHAUFFEUR_NOT_ELIGIBLE') :
                this.resourceService.get('BRANDED_FARE_TYPES_CHAUFFEUR_ELIGIBLE');
        }

        public containPieceBaggageConcept(fareTypes: IBrandedFareType[], sectorNumber: number): boolean {
            let res = false;
            for (let i = 0; i < fareTypes.length; ++i) {
                const sector = fareTypes[i].FlightSectors[sectorNumber];
                if (sector.BaggageType === 'PIECE_CONCEPT') {
                    res = true;
                    break;
                }
            }
            return res;
        }

        public calculateTotalFares(fare, qtys) {
            if (fare && qtys && fare.AdultFare && fare.AdultFare.Amount) {
                let adultCost = fare.AdultFare.Amount;
                let adultQty = qtys.AdultFareQuantity;
                let childCost = fare.ChildFare.Amount;
                let childQty = qtys.ChildFareQuantity;
                let infantCost = fare.InfantFare.Amount;
                let infantQty = qtys.InfantFareQuantity;
                let totalAdultFares = adultCost * adultQty;
                let totalChildFares = childCost * childQty;
                let totalInfantFares = infantCost * infantQty;
                let totalFares = totalAdultFares + totalChildFares + totalInfantFares;
                return totalFares;
            }
        }

        public calculateTotalTaxes(fare, qtys) {
            if (fare && qtys && fare.AdultTax && fare.AdultTax.Amount) {
                let adultTaxCost = fare.AdultTax.Amount;
                let adultTaxQty = qtys.AdultTaxQuantity;
                let childTaxCost = fare.ChildTax.Amount;
                let childTaxQty = qtys.ChildTaxQuantity;
                let infantTaxCost = fare.InfantTax.Amount;
                let infantTaxQty = qtys.InfantTaxQuantity;
                let totalAdultTax = adultTaxCost * adultTaxQty;
                let totalChildTax = childTaxCost * childTaxQty;
                let totalInfantTax = infantTaxCost * infantTaxQty;
                let totalTaxes = totalAdultTax + totalChildTax + totalInfantTax;
                return totalTaxes;
            }
        }

        public getPriceQtys(data) {
            return data;
        }

        public setSkywards(arr) {
            arr.AccruedMiles = [{
                Miles: 0
            }];
        }

        public setPriceDifference(arr, defaultPrice, i) {
            let farePrice = arr[i].BrandedFareTypeTotalPrice;
            let priceDiff = Math.ceil(farePrice - defaultPrice);
            arr[i].BrandedFarePriceDifference = priceDiff;
        }

        public getPriceDifference(fareTypes) {
            let defaultPrice;
            let undefinedIndexes: number[] = [];
            for (let i = 0; i < fareTypes.length; i++) {

                if (fareTypes[i].IsSelected) {
                    defaultPrice = fareTypes[i].BrandedFareTypeTotalPrice;
                }

                if (defaultPrice === undefined) {
                    undefinedIndexes.push(i);
                }

                this.setPriceDifference(fareTypes, defaultPrice, i);
            }

            if (undefinedIndexes.length > 0) {
                for (let j = 0; j < undefinedIndexes.length; j++) {
                    this.setPriceDifference(fareTypes, defaultPrice, j);
                }
            }

            return fareTypes;
        }

        public getDepartureCode(legs) {
            if (legs) {
                for (let i = 0; i < legs.length; i++) {
                    if (legs[i].LegType === 'outbound') {
                        return legs[i].DepartureAirport.Code;
                    }
                }
            }
        }

        public getDestinationCode(legs) {
            if (legs) {
                for (let i = 0; i < legs.length; i++) {
                    if (legs[i].LegType === 'outbound') {
                        return legs[i].ArrivalAirport.Code;
                    }
                }
            }
        }

        public getDepartureDate(legs) {
            for (let i = 0; i < legs.length; i++) {
                if (legs[i].LegType === 'outbound') {
                    return legs[i].DepartureDate;
                }
            }
        }

        public async collatePayloads(payload, domainId) {
            this.allPayloads.push(payload);
            let elemCount = document.querySelectorAll('.flight-listing-container').length;
            elemCount = elemCount - 1;
            if (this.allPayloads.length === elemCount) {
                let theCall = await this.callMilesApi(this.allPayloads, domainId);
                sessionStorage.setItem('flightsSkywards', JSON.stringify(theCall));
                TRPCONFIG.Domain.flightsSkywards = theCall;
                return theCall;
            }
        }


        public async callMilesApi(payload, domainId) {
            try {
                let url = `/api/skywards/Accrual/getMiles?domainId=${domainId}&bookingChannelId=2`;
                const response = await fetch(url, {
                    method: 'post',
                    body: JSON.stringify(payload),
                    mode: 'cors',
                    headers: new Headers({
                        'Content-Type': 'application/json'
                    })
                });

                const miles = await response.json();
                return miles;
            } catch (error) {
                console.log('error', error);
                throw error;
            }

        }

        public async payloadEntry(id, trip, legs, hotel, price) {
            let domainId = TRPCONFIG.Domain.DomainId;
            let tripHotel;
            let pid = id;
            if (trip.HotelsRequest) {
                tripHotel = trip.HotelsRequest;
            } else {
                tripHotel = trip.HotelInfo;
            }
            if (id === null) {
                pid = this.guidService.uuid();
            }

            let payload =
            {
                id: pid,
                price: price,
                bookingDate: this.dateUtil.serialiseDate(Date.now()),
                flights: [
                    {
                        departureAirportCode: this.getDepartureCode(legs),
                        departureDate: this.dateUtil.serialiseDate(this.getDepartureDate(legs))
                    }
                ],
                hotels: [
                    {
                        estabGroupIds: hotel.EstabGroupIds,
                        checkInDate: tripHotel.CheckInDate
                    }
                ]
            };
            return await this.callMilesApi([payload], domainId);
        }

        private languageCheck(cabinType) {
            switch (cabinType) {
                case 'Economy':
                case 'Økonomi klasse':
                case 'Economy Class':
                case 'Ekonomiklass':
                case 'الدرجة السياحية':
                case 'Clase Turista':
                    return 'Economy';
                case 'Premium Economy':
                case 'Premium ekonomiklass':
                case 'الدرجة الاقتصادية المميزة':
                case 'Clase Turista Premium':
                    return 'Premium Economy';
                case 'Business':
                case 'Business Class':
                case 'درجة رجال الأعمال':
                case 'Clase Business':
                    return 'Business';
                case 'First':
                case 'Erste Klasse':
                case 'Första klass':
                case 'الدرجة الأولى':
                case 'Primera clase':
                    return 'First';
                default:
                    return '';
            }
        }

        private getCabin(fareBrandLeg, cabinLeg) {
            let legArr = fareBrandLeg.split(' ');
            let updatedLegArr: any = [];

            let isPremium = legArr.includes('Premium');

            if (isPremium) {
                legArr.splice(0, 2);
            }

            legArr.forEach((cabin, i) => {
                if (cabin !== cabinLeg) {
                    if ((cabinLeg !== 'Premium Economy' && i === 1) ||
                        (cabinLeg === 'Premium Economy' && i === 0)) {
                        cabin = cabin.toLowerCase();
                    }
                    updatedLegArr.push(cabin);
                }
            });
            return updatedLegArr;
        }

        private getCabinCode(cabinType) {
            switch (cabinType) {
                case 'Economy':
                    return 'Y';
                case 'Premium Economy':
                    return 'W';
                case 'Business':
                    return 'J';
                case 'First':
                    return 'F';
                default:
                    return '';
            }
        }

        private getFlightMiles(hotelSearch, origin, destination, cabinCodeLeg, journeyType, fareBrandLegResult) {
            if (origin && destination && cabinCodeLeg && journeyType) {
                return hotelSearch.getFlightMiles(origin, destination, cabinCodeLeg, journeyType)
                    .then(result => {
                        const cabin = `${cabinCodeLeg}${journeyType}`;
                        let milesValue = result.getMilesFromCouchbase.miles.earn.skywards;
                        let milesMap = { [cabin]: milesValue };
                        if (sessionStorage.getItem('combinedFlightMiles')) {
                            let milesData = JSON.parse(sessionStorage.getItem('combinedFlightMiles') || '{}');
                            let keys: any[] = [];
                            milesData.forEach((m) => {
                                keys.push(Object.keys(m)[0]);
                            });
                            if (keys.indexOf(cabin) < 0) {
                                milesData.push(milesMap);
                                sessionStorage.setItem('combinedFlightMiles', JSON.stringify(milesData));
                            }
                        } else {
                            if (milesMap) {
                                sessionStorage.setItem('combinedFlightMiles', JSON.stringify([milesMap]));
                            }
                        }
                        if (result.getMilesFromCouchbase.miles &&
                            result.getMilesFromCouchbase.miles.earn &&
                            result.getMilesFromCouchbase.miles.earn.skywards[fareBrandLegResult]) {
                            return result.getMilesFromCouchbase.miles.earn.skywards[fareBrandLegResult].skywardsMiles;
                        }
                    });
            }
        }


        public async getFareInfo
            (fareOrLegsSelection, fareOrLegsAndBrandtitles, bft, fare,
                hotelSearch, origin, destination, getBrandTitleFirstLeg, getBrandTitleSecondLeg) {
            bft = Number(bft);
            const cabinTypes = { 1: 'Economy', 2: 'Premium Economy', 8: 'Business', 4: 'First' };
            const cabinCodes = { 1: 'Y', 2: 'W', 8: 'J', 4: 'F' };

            let flight = fare.FlightSectors;

            if (!fare.FlightSectors) {
                flight = fare.Legs;
            }

            if (fareOrLegsSelection && fareOrLegsSelection !== undefined) {
                if (fareOrLegsAndBrandtitles) {
                    let journeyType ='RT';
                    let fareBrand = flight[0].BrandTitle;
                    let cabinType = flight[0].CabinType;

                    if (!fareBrand) {
                        fareBrand = getBrandTitleFirstLeg;
                    }

                    cabinType = this.languageCheck(cabinType);
                    let updatedFirstLegArr = this.getCabin(fareBrand, cabinType);
                    let fareBrandResult = updatedFirstLegArr.join('');

                    const cabinCode = cabinCodes[flight[0].Segments[0].Cabin];

                    bft = await this.getFlightMiles
                        (hotelSearch, origin, destination, cabinCode, journeyType, fareBrandResult);
                } else {
                    let journeyType ='OW';
                    let fareBrandFirstLeg = flight[0].BrandTitle;
                    let cabinTypeFirstLeg = cabinTypes[flight[0].Segments[0].Cabin];
                    let fareBrandSecondLeg = flight[1].BrandTitle;
                    let cabinTypeSecondLeg = cabinTypes[flight[1].Segments[0].Cabin];

                    if (!fareBrandFirstLeg) {
                        fareBrandFirstLeg = getBrandTitleFirstLeg;
                    }

                    if (!fareBrandSecondLeg) {
                        fareBrandSecondLeg = getBrandTitleSecondLeg;
                    }

                    cabinTypeFirstLeg = this.languageCheck(cabinTypeFirstLeg);
                    cabinTypeSecondLeg = this.languageCheck(cabinTypeSecondLeg);

                    let updatedFirstLegArr = this.getCabin(fareBrandFirstLeg, cabinTypeFirstLeg);
                    let updatedSecondLegArr = this.getCabin(fareBrandSecondLeg, cabinTypeSecondLeg);

                    let fareBrandFirstLegResult = updatedFirstLegArr.join('');
                    let fareBrandSecondLegResult = updatedSecondLegArr.join('');

                    let cabinCodefirstLeg =
                        cabinCodes[flight[0].Segments[0].Cabin];
                    let cabinCodeSecondLeg =
                        cabinCodes[flight[1].Segments[0].Cabin];
                    let skywardFlightMileForFirstLeg =
                        await this.getFlightMiles(hotelSearch, origin, destination,
                        cabinCodefirstLeg, journeyType, fareBrandFirstLegResult);
                    let skywardFlightMileForSecondLeg =
                        await this.getFlightMiles(hotelSearch, origin, destination,
                        cabinCodeSecondLeg, journeyType, fareBrandSecondLegResult);

                    bft = parseInt(skywardFlightMileForFirstLeg,10)+
                        parseInt(skywardFlightMileForSecondLeg,10);
                }
            } else {
                if (fare.Legs[0].BrandTitle === fare.Legs[1].BrandTitle) {
                    let  journeyType = 'RT';
                    let fareBrand = fare.Legs[0].BrandTitle;
                    let cabinType = fare.Legs[0].CabinType;

                    cabinType = this.languageCheck(cabinType);
                    let updatedFirstLegArr = this.getCabin(fareBrand, cabinType);
                    let fareBrandResult = updatedFirstLegArr.join('');
                    let cabinCode = cabinCodes[fare.Legs[0].Segments[0].Cabin];

                    bft = await this.getFlightMiles(hotelSearch, origin, destination,
                        cabinCode, journeyType, fareBrandResult);
                } else {
                    let journeyType ='OW';
                    let cabinTypeFirstLeg = fare.Legs[0].CabinType;
                    let cabinTypeSecondLeg = fare.Legs[1].CabinType;
                    let fareBrandFirstLeg = fare.Legs[0].BrandTitle;
                    let fareBrandSecondLeg = fare.Legs[1].BrandTitle;

                    cabinTypeFirstLeg = this.languageCheck(cabinTypeFirstLeg);
                    cabinTypeSecondLeg = this.languageCheck(cabinTypeSecondLeg);

                    let updatedFirstLegArr = this.getCabin(fareBrandFirstLeg, cabinTypeFirstLeg);
                    let updatedSecondLegArr = this.getCabin(fareBrandSecondLeg, cabinTypeSecondLeg);

                    let fareBrandFirstLegResult = updatedFirstLegArr.join('');
                    let fareBrandSecondLegResult = updatedSecondLegArr.join('');

                    let cabinCodefirstLeg = cabinCodes[fare.Legs[0].Segments[0].Cabin];
                    let cabinCodeSecondLeg = cabinCodes[fare.Legs[1].Segments[0].Cabin];

                    let skywardFlightMileForFirstLeg =
                        await this.getFlightMiles(hotelSearch, origin, destination,
                        cabinCodefirstLeg, journeyType, fareBrandFirstLegResult);

                    let skywardFlightMileForSecondLeg =
                        await this.getFlightMiles(hotelSearch, origin, destination,
                            cabinCodeSecondLeg, journeyType, fareBrandSecondLegResult);

                    bft = parseInt(skywardFlightMileForFirstLeg,10)+
                        parseInt(skywardFlightMileForSecondLeg,10);
                }
            }
            this.flightMilesToPkgPP = bft;
            return bft;
        }

        private _getCabin(sector: IFlightSector) {
            return sector.Segments[0].Cabin;
        }

        private _getAttribute(leg, attrType: AttributeTypes): { [key: string]: any } {
            return _.find(leg.BrandAttributes, { AttributeType: attrType });
        }

        public _getTransformedType(brandTitle: string): TransformedType {
            switch (brandTitle.trim().toLowerCase()) {
                case 'economy special':
                    return TransformedType.EconomySpecial;
                case 'eco special':
                    return TransformedType.EconomySpecial;
                case 'economy saver':
                    return TransformedType.EconomySaver;
                case 'eco saver':
                    return TransformedType.EconomySaver;
                case 'economy flex':
                    return TransformedType.EconomyFlex;
                case 'eco flex':
                    return TransformedType.EconomyFlex;
                case 'economy flex plus':
                    return TransformedType.EconomyFlexPlus;
                case 'eco flexplus':
                    return TransformedType.EconomyFlexPlus;
                case 'premium economy flex plus':
                    return TransformedType.PremiumEconomyFlexPlus;
                case 'prem eco flexplus':
                    return TransformedType.PremiumEconomyFlexPlus;
                case 'business special':
                    return TransformedType.BusinessSpecial;
                case 'business saver':
                    return TransformedType.BusinessSaver;
                case 'business flex':
                    return TransformedType.BusinessFlex;
                case 'business flex plus':
                    return TransformedType.BusinessFlexPlus;
                case 'business flexplus':
                    return TransformedType.BusinessFlexPlus;
                case 'first saver':
                    return TransformedType.FirstSaver;
                case 'first flex':
                    return TransformedType.FirstFlex;
                case 'first flex plus':
                    return TransformedType.FirstFlexPlus;
                case 'first flexplus':
                    return TransformedType.FirstFlexPlus;
                default:
                    return TransformedType.NotDefined;
            }
        }

        public getClassName(fc) {
            let classObj = {
                'F': 'First Flex Plus',
                'A': 'First Flex',
                'Z': 'First Others',
                'J': 'Business Flex Plus',
                'C': 'Business Flex Plus',
                'I': 'Business Flex',
                'O': 'Business Saver',
                'H': 'Business Special',
                'D': 'Business Others',
                'P': 'Business Others',
                'W': 'Premium Economy Flex Plus',
                'E': 'Premium Economy Flex Plus',
                'N': 'Premium Economy Others',
                'Y': 'Economy Flex Plus',
                'R': 'Economy Flex Plus',
                'M': 'Economy Flex',
                'B': 'Economy Flex',
                'U': 'Economy Flex',
                'K': 'Economy Flex',
                'Q': 'Economy Saver',
                'L': 'Economy Saver',
                'T': 'Economy Saver',
                'X': 'Economy Special',
                'V': 'Economy Special',
                'G': 'Economy Others',
                'S': 'Economy Others'
            };

            let coKey = Object.keys(classObj);
            for(let i = 0; i < coKey.length; i++) {
                if (coKey[i] === fc) {
                    return classObj[coKey[i]];
                }
            }
        }

        public getBookingClassName(fc) {
            let classObj = {
                'F': 'Flex Plus',
                'A': 'Flex',
                'Z': 'Others',
                'J': 'Flex Plus',
                'C': 'Flex Plus',
                'I': 'Flex',
                'O': 'Saver',
                'H': 'Special',
                'D': 'Others',
                'P': 'Others',
                'W': 'Flex Plus',
                'E': 'Flex Plus',
                'N': 'Others',
                'Y': 'Flex Plus',
                'R': 'Flex Plus',
                'M': 'Flex',
                'B': 'Flex',
                'U': 'Flex',
                'K': 'Flex',
                'Q': 'Saver',
                'L': 'Saver',
                'T': 'Saver',
                'X': 'Special',
                'V': 'Special',
                'G': 'Others',
                'S': 'Others'
            };

            let coKey = Object.keys(classObj);
            for(let i = 0; i < coKey.length; i++) {
                if (coKey[i] === fc) {
                    return classObj[coKey[i]];
                }
            }
        }

        public _setClassName(type: ekh.TransformedType) {
            switch (type) {
                case ekh.TransformedType.EconomySpecial:
                    return 'economy-special';
                case ekh.TransformedType.EconomySaver:
                    return 'economy-saver';
                case ekh.TransformedType.EconomyFlex:
                    return 'economy-flex';
                case ekh.TransformedType.EconomyFlexPlus:
                    return 'economy-flex-plus';
                case ekh.TransformedType.PremiumEconomyFlexPlus:
                    return 'premium-economy-flex-plus';
                case ekh.TransformedType.BusinessSpecial:
                    return 'business-special';
                case ekh.TransformedType.BusinessSaver:
                    return 'business-saver';
                case ekh.TransformedType.BusinessFlex:
                    return 'business-flex';
                case ekh.TransformedType.BusinessFlexPlus:
                    return 'business-flex-plus';
                case ekh.TransformedType.FirstSaver:
                    return 'first-saver';
                case ekh.TransformedType.FirstFlex:
                    return 'first-flex';
                case ekh.TransformedType.FirstFlexPlus:
                    return 'first-flex-plus';
                default:
                    return '';
            }
        }

    }

    angular
        .module('ekh')
        .service('brandedFareTypesService', BrandedFareTypesService);
}
